class DeleteFacility {
	constructor(
		public readonly organizationId: number,
		public readonly facilityId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteFacility;
